import React, {useState} from 'react';
import {Container, Col, Row} from 'reactstrap';
import Sticky from 'react-sticky-el';

const StickySearchParametersHolderComponent = (props) => {

    const [fixedPosition, setFixedPosition] = useState(false)

    const scrollToTop = () => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
          } 
    }
    
    return (
        <Sticky  stickyClassName={`sticky-thc`} onFixedToggle = {() => setFixedPosition(!fixedPosition)} >
        <Container className="sticky-search-parameters-holder text-center" onClick = {()=> fixedPosition ? scrollToTop() : null}>
           
                <Row>
                    <Col className="countries">
                    {props.selectedCountries.map((country, index) => {

                        return <span className="ml-1 country-item bold" key={index}>
                                        <bdi>{country.countryHebName}</bdi>
                                        {index < (props.selectedCountries.length - 1) ? ',':''}
                                </span>

                            })}
                    </Col>
                </Row>
                <Row>
                    <Col className="text-center">
                        <span className="small-border-bottom text-center d-block"></span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span className="bold d-block days">חבילות ל {parseInt(props.selectedDaysCount)} ימים</span> 
                    </Col>
                </Row>
           
        </Container>
        </Sticky> 
    )
}


export default StickySearchParametersHolderComponent;